import script from "./RoleRequiredByDay.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRequiredByDay.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRequiredByDay.vue?vue&type=style&index=0&id=1e7097d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e7097d8"]])

export default __exports__